const ITEMS = [
  "Mortlake Car Club",
  "Est. 1968",
  "Formula 500s",
  "Wingless Sprints",
  "Street Stocks",
  "Super Rods",
  "Junior Karts",
  "Darlington Victoria",
  "310M Black Clay Oval",
];

export default function Marquee() {
  const strip = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-display font-bold uppercase tracking-widest text-2xl sm:text-3xl text-clay-text/90 px-6 whitespace-nowrap">
            {item}
          </span>
          <span className="w-2 h-2 bg-clay-orange rotate-45 shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className="relative border-y border-clay-border bg-clay-surface py-5 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {strip}
        {strip}
      </div>
    </div>
  );
}
